import { qo } from '../../../shared/dom';

/** Ajusta os canvases de efeito ao tamanho real do palco (em devicePixelRatio). */
export function sizeCanvases(): void {
  ['#confetti', '#motes', '#coins'].forEach(sel => {
    const c = qo<HTMLCanvasElement>(sel);
    if (!c || !c.offsetWidth) return;
    c.width = c.offsetWidth * devicePixelRatio;
    c.height = c.offsetHeight * devicePixelRatio;
  });
}

export function ctx2d(c: HTMLCanvasElement): CanvasRenderingContext2D {
  const x = c.getContext('2d');
  if (!x) throw new Error('Canvas 2D indisponível');
  return x;
}
